(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tiers"] && !Shopify.designMode) return;
  try {
    
  class ProductTiersSlider extends HTMLElement {
    constructor() {
      super();
      this._index = 0;
      this._timer = null;
      this._paused = false;
    }

    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.dots = Array.from(this.querySelectorAll('.product-tiers__dot'));
      if (!this.track) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(1500, parseInt(this.dataset.interval, 10) || 4000);

      this._onScroll = this._debounce(this._handleScroll.bind(this), 80);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this._pauseTemp();
          this._scrollTo(parseInt(dot.dataset.index, 10));
        });
      });

      this.addEventListener('pointerdown', () => this._pauseTemp(), { passive: true });
      this.addEventListener('pointerleave', () => this._maybeResume());

      this._media = window.matchMedia('(max-width: 749px)');
      this._mediaListener = () => this._refresh();
      this._media.addEventListener
        ? this._media.addEventListener('change', this._mediaListener)
        : this._media.addListener(this._mediaListener);

      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._refresh();
      this._setActiveDot(0);
    }

    disconnectedCallback() {
      this._stop();
      if (this._media && this._media.removeEventListener) {
        this._media.removeEventListener('change', this._mediaListener);
      } else if (this._media) {
        this._media.removeListener(this._mediaListener);
      }
    }

    _refresh() {
      if (this.autoplay && this._media.matches && !this._reducedMotion) {
        this._start();
      } else {
        this._stop();
      }
    }

    _start() {
      this._stop();
      this._timer = window.setInterval(() => {
        if (this._paused) return;
        const slides = this.track.children.length;
        const next = (this._index + 1) % slides;
        this._scrollTo(next);
      }, this.interval);
    }

    _stop() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    _scrollTo(index) {
      const slides = this.track.children;
      const target = slides[index];
      if (!target) return;
      const left = target.offsetLeft - (this.track.clientWidth - target.clientWidth) / 2;
      this.track.scrollTo({ left, behavior: 'smooth' });
      this._index = index;
      this._setActiveDot(index);
    }

    _setActiveDot(index) {
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('data-active', 'true');
        else dot.removeAttribute('data-active');
      });
    }

    _handleScroll() {
      const slides = Array.from(this.track.children);
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = 0;
      let min = Infinity;
      slides.forEach((slide, i) => {
        const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        const distance = Math.abs(slideCenter - center);
        if (distance < min) {
          min = distance;
          closest = i;
        }
      });
      this._index = closest;
      this._setActiveDot(closest);
    }

    _pauseTemp() {
      this._paused = true;
      clearTimeout(this._resumeTimer);
      this._resumeTimer = window.setTimeout(() => { this._paused = false; }, 4000);
    }

    _maybeResume() {
      clearTimeout(this._resumeTimer);
      this._resumeTimer = window.setTimeout(() => { this._paused = false; }, 1500);
    }

    _debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }
  }

  if (!customElements.get('product-tiers-slider')) {
    customElements.define('product-tiers-slider', ProductTiersSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
